// extracted by mini-css-extract-plugin
export var container = "_bz-0";